export const CLIENT_APP_EXCEPTION_FALLBACK_HTML = `
  <div style="padding: 12px">
    <div style="margin: 0 32px; color: #405368">
      <h1 style="textAlign: center, margin: 0 0 32px">Кажется, что-то пошло не так...</h1>
      <p style="textAlign: center, margin: 0 0 16px">Мы уже работаем над исправлением ошибки</p>
      <a href="/" style="textAlign: center">
        Вернуться на главную
      </a>
    </div>
  </div>
`;
